import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";

const CommentModal = ({
  isOpen,
  onClose,
  onSave,
  isLoading,
  comment,
  setComment,
  isEditing = false,
}) => {
  const { t } = useTranslation();
  const handleClose = () => {
    setComment("");
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={handleClose}
      contentClassName="rounded-lg"
      style={{ maxWidth: "600px" }}
      centered
    >
      <ModalHeader className="flex justify-between items-center pb-3 border-0">
        <span className="text-gray-900 font-semibold text-base">
          {isEditing ? t("Edit comment") : t("Add a comment")}
        </span>
        <CloseIcon
          style={{
            color: "#6B7280",
            cursor: "pointer",
            fontSize: "20px",
          }}
          onClick={handleClose}
        />
      </ModalHeader>
      <ModalBody className="px-6">
        <textarea
          className="w-full min-h-[140px] border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-900 outline-none focus:border-[#2AB9B8] focus:ring-2 focus:ring-[#2AB9B8] resize-none"
          placeholder={t("Your comment")}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
      </ModalBody>
      <ModalFooter className="flex justify-end gap-2 pt-4 pb-4 border-0 px-6">
        <button
          type="button"
          onClick={handleClose}
          className="px-4 py-2 border border-gray-300 rounded-full text-gray-700 bg-white hover:bg-gray-50 text-sm font-medium"
        >
          {t("Cancel")}
        </button>
        <button
          type="button"
          onClick={onSave}
          disabled={!comment.trim() || isLoading}
          className="px-4 py-2 bg-[#2AB9B8] text-white rounded-full hover:bg-[#009493] disabled:opacity-50 text-sm font-medium"
        >
          {isEditing ? t("Update") : t("Add")}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default CommentModal;
